import { __awaiter } from 'tslib';

const ENDPOINT = 'GETartistpromotionrequest';
var ARTIST_PROMOTIONS_STATUS;
(function (ARTIST_PROMOTIONS_STATUS) {
    ARTIST_PROMOTIONS_STATUS["approved"] = "approved";
    ARTIST_PROMOTIONS_STATUS["contacted"] = "contacted";
    ARTIST_PROMOTIONS_STATUS["pending"] = "pending";
    ARTIST_PROMOTIONS_STATUS["rejected"] = "rejected";
    ARTIST_PROMOTIONS_STATUS["pendingpayment"] = "pendingpayment";
})(ARTIST_PROMOTIONS_STATUS || (ARTIST_PROMOTIONS_STATUS = {}));
function getArtistPromotionRequest(gateway, params, customURL = null, customHeaders = null, isKoussa = false) {
    return __awaiter(this, void 0, void 0, function* () {
        return gateway.get(getArtistPromotionRequest.endpoint, params, customURL, customHeaders, isKoussa);
    });
}
getArtistPromotionRequest.endpoint = ENDPOINT;

export { ARTIST_PROMOTIONS_STATUS, getArtistPromotionRequest as default };
//# sourceMappingURL=getArtistPromotionRequest.js.map
